import React, { FC, useEffect, useRef, useState } from 'react'
import { Button, Table, Input, message, Upload, Checkbox, Tooltip, Image, notification } from 'antd'
import { YhBox } from '@/components/YhBox'
import { ColumnsType } from 'antd/es/table'
import { RouterParamType } from '@/model/navModel'
import { EditableRow, EditableCell } from '@/components/YHEditTable/editTable'
import useGlobalModel from '@/model/globalModel'
import { useDictModel } from '@/views/base/dict/dictModel'
import { formatInt, formatNum, formatDiscount } from '@/utils/utils'
import { YhAuth } from '@/components/auth/YhAuth'
import { ISCMSDcGoodsDetail } from '../../applyListTypes'
import { useApplyListDetailsModel } from './applyListDetailsModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { ExclamationCircleOutlined, PlusSquareTwoTone } from '@ant-design/icons'
import { warehouseService } from '@/views/base/warehouseManage/warehouseService'
import { globalPrompt } from '@/components/message'
import { debounce } from 'lodash'
import { applyListService } from '../../applyListService'
import { getBaseImgLookUrl } from '@/utils/constants'
import { ResourceAuthEnum } from '@/types/AppResourceAuthEnum'
import YhTootip from '@/components/YhTootip'
import { importPropsConfig } from '@/utils/importFile'
import { ChangeWarehouseModel } from './ChangeWarehouseModel'
import { AddWarehouseShelfModal } from './AddWarehouseShelfModal'

type ISCMSDcGoodsSearch = {
    data: ISCMSDcGoodsDetail[]
    isSearch: boolean
}

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { warehouseList, setLoadingInfo, shopAndOrg, userList, userOrgList, fetchUserList } = useGlobalModel()
    const { getSelectedDictValueOne, getSelectedDictOne, getTreeNodeName } = useDictModel(() => [])
    const {
        addGoodsList,
        addFormVal,
        editFormVal,
        editFormVal: { status },
        transformsToSDcGoods,
        setButtonControl,
        setAddGoodsList,
        editGoodsList,
        setEditGoodsList,
        setSaveBtn,
        setAddGoodsModal,
        downloadTpl,
        selectedRowRows,
        setSelectedRowRows,
        selectedKeys,
        setSelectedKeys,
        getOneNameList
    } = useApplyListDetailsModel()

    const [searchParms, setSearchParms] = useState<string>('')
    const [searchVal, setSearchVal] = useState<ISCMSDcGoodsSearch>({ data: [], isSearch: false }) //用于搜索展示的数据

    const [changeWarehouseVisible, setChangeWarehouseVisible] = useState(false)
    const formRef = useRef<any>()
    const dataSource = mode === 'edit' ? editGoodsList : addGoodsList
    //删除商品
    const onRemove = () => {
        if (!selectedKeys.length) {
            message.warning('请选择你要删除的商品')
            return
        }
        mode === 'edit'
            ? setEditGoodsList((origin) => origin.filter((item) => selectedKeys.indexOf(item.detailsId) < 0))
            : setAddGoodsList((origin) => origin.filter((item) => selectedKeys.indexOf(item.detailsId) < 0))

        let newSearchData = searchVal.data.filter((item) => selectedKeys.indexOf(item.detailsId) < 0)
        setSearchVal({ data: newSearchData, isSearch: searchVal.isSearch })
        mode === 'add' ? setButtonControl(false) : setButtonControl(true)
        setSelectedKeys([])
        message.success('删除成功')
    }
    //实时详情列表货位数据
    const [shelfAllList, setShelfAllList] = useState<any>([])
    const changeshelfCode = async (value, options) => {
        let newRecords: any = []
        let params = {
            pageSize: 99999,
            pageNum: 1,
            ...shopAndOrg,
            warehouseId: warehouseList.find((item) => item.value === value.warehouseCode)?.id,
            warehouseCode: value.warehouseCode,
            enable: "1"
        }
        const { retData: shelfAll } = await warehouseService.shelfAllPage(params)
        newRecords = shelfAll.map((item) => {
            return { ...item, label: item.code as string, value: item.code }
        })
        setShelfAllList(newRecords)
    }
    const importCallback = async (list: any) => {
        setLoadingInfo({ loadingVisible: false, txt: '' })
        if (list && list.length) {
            let str = ''
            let newData: any = []
            list.map((object, index) => {
                if (object.status) {
                    console.log(object.assetsDetails);
                    let item = object.assetsDetails
                    // object.assetsDetails.map((item) => {
                    newData.push({
                        ...item,
                        temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000),
                    })
                    // })
                } else {
                    str += `【第${index + 1}条导入失败：${object.msg}】`
                }
            })
            // transformsToSDcGoods(newData, mode)
            mode == 'edit'
                ? setEditGoodsList((origin) => [...origin, ...newData])
                : setAddGoodsList((origin) => [...origin, ...newData]);
            str ? notification.warning({ message: '提醒', description: str, duration: 9 }) : message.success('导入成功')
        }
    }

    //搜索  前端自己保存搜索的值， 搜索值为空还是用缓存
    const goodsFilter = (dataSource: ISCMSDcGoodsDetail[] | null = null) => {
        const isEtit = mode !== 'add'
        let goodsList = dataSource ? dataSource : [...(isEtit ? editGoodsList : addGoodsList)]
        if (searchParms) {
            let reg = new RegExp(searchParms)
            let arr: ISCMSDcGoodsDetail[] = []
            goodsList.forEach((item) => {
                if (item.materialCode?.match(reg) || item.materialName?.match(reg)) {
                    arr.push(item)
                }
            })

            setSearchVal({ data: arr, isSearch: true })

            if (!arr.length) {
                message.warning('列表没有该商品！！')
                setSearchVal({ data: [], isSearch: false })
            }
        } else {
            setSearchVal({ data: [], isSearch: false })
        }
    }
    const dataSourse = mode === 'add' ? addFormVal : editFormVal
    const onfocusUserCode = () => {
        fetchUserList(mode == 'add' ? addFormVal.department : editFormVal.department)
        // fetchUserList(dataSourse.typeCode!=='assets-apply-type.transfer'?dataSourse.department:dataSourse.departmentIn)
    }

    // 新增
    const onAdd = () => {
        if (dataSourse.typeCode == 'assets-apply-type.transfer') {
            if (!(mode == 'add' ? addFormVal.department : editFormVal.department)) {
                return message.warning('请先选择，转入部门')
            }
            if (!(mode == 'add' ? addFormVal.departmentOut : editFormVal.departmentOut)) {
                return message.warning('请先选择，转出部门')
            }
            setAddGoodsModal(true)
        }
        if (dataSourse.typeCode == 'assets-apply-type.discard') {
            if (!(mode == 'add' ? addFormVal.department : editFormVal.department)) {
                return message.warning('请先选择，所属部门')
            }
            setAddGoodsModal(true)
        }
        if (!getOneNameList.length) {
            setAddGoodsModal(false)
            return message.warning('请先完善审批流程！')
        }
        if (dataSourse.typeCode == 'assets-apply-type.discard' && !dataSourse.materialTypeCode) {
            setAddGoodsModal(false)
            return message.warning('请先选择物料类别！')
        } else {
            setAddGoodsModal(true)
        }
    }
    const onUpload = () => {
        if (!dataSourse.department || !dataSourse.departmentOut) {
            return message.warning('请先选择，转入部门、转出部门')
        }
    }
    const action = (
        <div className="flex justify-between white-space">
            <div>
                <YhAuth resCode={ResourceAuthEnum.ASSETS_S_M_ED_AD}>
                    <Button className="mr-5" type="link" shape="round" onClick={onAdd} disabled={mode == 'look'}>
                        新增物品
                    </Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.ASSETS_S_M_ED_DEL}>
                    <Button className="mr-5" type="link" shape="round" onClick={() => onRemove()} disabled={mode == 'look'}>
                        删除物品
                    </Button>
                </YhAuth>
                {dataSourse.typeCode == 'assets-apply-type.transfer' && (
                    <>
                        {' '}
                        <Button className="mr-5" type="link" shape="round" onClick={downloadTpl}>
                            下载模板
                        </Button>
                        <Upload
                            disabled={!dataSourse.department || !dataSourse.departmentOut}
                            showUploadList={false}
                            className="mr-10 ml-10"
                            {...importPropsConfig(
                                `/assets/assets/importTransferDetails`,
                                importCallback,
                                () => setLoadingInfo({ loadingVisible: true, txt: '快速导入中...' }),
                                { department: dataSourse.department, departmentOut: dataSourse.departmentOut },
                                false
                            )}
                        >
                            <Button className="mr-5" type="link" shape="round" onClick={() => onUpload()}>
                                导入
                            </Button>
                        </Upload>
                    </>
                )}
                {dataSource.length > 0 && (
                    <Button className="mr-5" type="link" shape="round" onClick={() => {
                        if (selectedKeys.length == 0) {
                            return message.warning('请选择要调整的物资！')
                        }
                        else {
                            setChangeWarehouseVisible(true)
                        }
                    }} disabled={mode == 'look'}>
                        仓库货位批量调整
                    </Button>
                )}
            </div>
            <div className="flex">
                <Input
                    size="small"
                    allowClear
                    datatype="round"
                    className="border-r-8 ml-10"
                    placeholder="物资编号/物资名称"
                    onChange={(e) => {
                        setSearchParms(e.target.value)
                    }}
                    onBlur={(e) => setSearchParms(e.target.value?.trim())}
                // onPressEnter={() => goodsFilter()}
                />
                <Button type="primary" style={{ margin: '0px 12px 0px 15px' }} shape="round" onClick={() => goodsFilter()}>
                    {' '}
                    查询
                </Button>
            </div>
        </div>
    )
    const [addShelfVisible, setAddShelfVisible] = useState<boolean>(false);
    const handleOpenAddShelf = async () => {
        setAddShelfVisible(true);
    }
    const abandonColumns = [
        {
            title: '序号',
            width: 50,
            fixed: 'left',
            align: 'center',
            render: (t: any, r: any, i: number) => i + 1,
        },
        {
            title: '物资图片',
            width: 140,
            align: 'center',
            fixed: 'left',
            render: (text, records) => (records.md5 ? <Image src={getBaseImgLookUrl(records.md5)} style={{ maxWidth: '50px', maxHeight: '70px' }} /> : null),
        },
        {
            title: '物资编码',
            width: 140,
            dataIndex: 'materialCode',
            fixed: 'left',
        },
        {
            title: '物资名称',
            width: 160,
            dataIndex: 'materialName',
            fixed: 'left',
        },
        {
            title: '物资类型',
            width: 100,
            dataIndex: 'typeCode',
            render: (text: string) => getTreeNodeName(text) ?? '',
        },
        {
            title: '规格型号',
            width: 130,
            dataIndex: 'model',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '单位',
            width: 80,
            dataIndex: 'unitCode',
            render: (text: string) => getSelectedDictOne(DictCodeEnmu.ASSETS_UNIT).find((item) => item.value === text)?.label ?? '',
        },
        {
            title: '单价',
            width: 90,
            dataIndex: 'price',
            render: (text: any) => `￥${formatNum(text)}`,
        },
        {
            title: '报废数量',
            width: 100,
            dataIndex: 'num',
        },
        {
            title: '合计',
            width: 100,
            dataIndex: 'amount',
            render: (text: any) => `￥${formatNum(text ?? 0)}`,
        },
        // {
        //     title: '当前存放地点',
        //     width: 130,
        //     dataIndex: 'deposit',
        // },
        {
            title: '条形码',
            width: 100,
            dataIndex: 'barCode',
        },
        {
            title: '备注',
            width: 140,
            dataIndex: 'note',
            editable: true,
        },
        {
            title: '仓库',
            width: 130,
            dataIndex: 'warehouseCode',
            editable: true,
            editType: 'select',
            options: warehouseList,
            // onSelectChange:changeWarehouseCode,
            render: (text: string) => warehouseList.find((item) => item.value === text)?.label ?? '',
            fixed: 'right',
        },
        {
            title: '货位',
            width: 130,
            dataIndex: 'shelfCode',
            editable: true,
            editType: 'select',
            options: shelfAllList,
            onSelectFocus: changeshelfCode,
            fixed: 'right',
        },
        // {
        //     title: '当前使用人',
        //     width: 120,
        //     dataIndex: 'userCode',
        //     // editable: true,
        //     editType: 'select',
        //     options: userList,
        //     render: (text: string) =>userList.find((item) => item.value === text)?.label ?? '',
        //     fixed: "right",
        // }
    ]
    const moveColumns = [
        {
            title: '序号',
            width: 50,
            fixed: 'left',
            align: 'center',
            render: (t: any, r: any, i: number) => i + 1,
        },
        {
            title: '物资图片',
            width: 140,
            align: 'center',
            fixed: 'left',
            render: (text, records) => (records.md5 ? <Image src={getBaseImgLookUrl(records.md5)} style={{ maxWidth: '50px', maxHeight: '70px' }} /> : null),
        },
        {
            title: '物资编码',
            width: 140,
            dataIndex: 'materialCode',
            fixed: 'left',
        },
        {
            title: '物资名称',
            width: 160,
            dataIndex: 'materialName',
            fixed: 'left',
        },
        {
            title: '物资类型',
            width: 100,
            dataIndex: 'typeCode',
            render: (text: string) => getTreeNodeName(text) ?? '',
        },
        {
            title: '规格型号',
            width: 130,
            dataIndex: 'model',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '单位',
            width: 80,
            dataIndex: 'unitCode',
            render: (text: string) => getSelectedDictOne(DictCodeEnmu.ASSETS_UNIT).find((item) => item.value === text)?.label ?? '',
        },
        {
            title: '单价',
            width: 90,
            dataIndex: 'price',
            render: (text: any) => `￥${formatNum(text)}`,
        },
        {
            title: '转移数量',
            width: 100,
            dataIndex: 'num',
        },
        {
            title: '合计',
            width: 100,
            dataIndex: 'amount',
            render: (text: any) => `￥${formatNum(text ?? 0)}`,
        },
        {
            title: '原存放地点',
            width: 130,
            dataIndex: 'beforeDeposit',
        },
        {
            title: '原使用人',
            width: 120,
            dataIndex: 'beforeUser',
        },
        {
            title: '转入地点',
            width: 130,
            dataIndex: 'deposit',
            editable: true,
        },
        {
            title: '备注',
            width: 140,
            dataIndex: 'note',
            editable: true,
        },
        {
            title: '仓库',
            width: 130,
            dataIndex: 'warehouseCode',
            editable: true,
            editType: 'select',
            options: warehouseList,
            // onSelectChange:changeWarehouseCode,
            render: (text: string) => warehouseList.find((item) => item.value === text)?.label ?? '',
            fixed: 'right',
        },
        {
            title: <span>货位
                <PlusSquareTwoTone
                    twoToneColor="#1890ff"
                    style={{ cursor: 'pointer', margin: '0 5px', fontSize: '15px' }}
                    onClick={() => {
                        handleOpenAddShelf()
                    }}
                /></span>,
            width: 170,
            dataIndex: 'shelfCode',
            editable: true,
            editType: 'select',
            options: shelfAllList,
            onSelectFocus: changeshelfCode,
            fixed: 'right',
        },
        {
            title: '现使用人',
            width: 120,
            dataIndex: 'userCode',
            editable: true,
            editType: 'select',
            options: userOrgList,
            // onSelectFocus: onfocusUserCode,
            render: (text: string, r) => userOrgList.find((item) => item.value === text)?.name ?? r.user,
            fixed: 'right',
        },
    ]
    const columns: any =
        addFormVal.typeCode == 'assets-apply-type.discard' || editFormVal.typeCode == 'assets-apply-type.discard' ? abandonColumns : moveColumns
    const newSelectColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col?.rules,
                options: col?.options,
                editType: col?.editType,
                editable: mode == 'look' ? false : col?.editable,
                onSelectChange: col?.onSelectChange,
                onSelectFocus: col?.onSelectFocus,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑   (计算价格)
    const handleSave = (row: ISCMSDcGoodsDetail) => {
        const index = dataSource.findIndex((item) => (row.temporaryId ? row.temporaryId === item.temporaryId : row.detailsId === item.detailsId))
        const item = dataSource[index]
        if (row.changeFields == 'warehouseCode') {
            row.warehouseName = warehouseList.find((item) => item.value === row.warehouseCode)?.label
            row.shelfCode = ''
        }
        if (row.changeFields == 'userCode') {
            row.user = userOrgList.find((item) => item.value === row.userCode)?.name
        }
        dataSource.splice(index, 1, { ...item, ...row })
        mode === 'edit' ? setEditGoodsList([...dataSource]) : setAddGoodsList([...dataSource])
        //判断展示的是搜索后的数据，然后搜索的也改变
        if (searchVal.isSearch) {
            goodsFilter(dataSource)
        }
        setButtonControl(true)
        setSaveBtn(true)
    }

    return (
        <YhBox title="" action={action} style={{ marginBottom: '75px' }}>
            <Table
                rowKey={(record) => record.detailsId}
                rowClassName={(record) => {
                    if (!record?.isHave || record.error) return 'editable-row yh-edit-table-tr background-FFB4B4'
                    return 'editable-row yh-edit-table-tr'
                }}
                rowSelection={{
                    selectedRowKeys: selectedKeys, //记录选中
                    onChange: (selectedKeys: React.Key[], selectedRows: ISCMSDcGoodsDetail[]) => {
                        setSelectedKeys(selectedKeys as string[])
                        setSelectedRowRows(selectedRows)
                    },
                }}
                bordered
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newSelectColumns as ColumnsType<ISCMSDcGoodsDetail>}
                dataSource={searchVal.isSearch ? searchVal.data : mode === 'add' ? addGoodsList : editGoodsList}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
            <ChangeWarehouseModel mode={mode} visible={changeWarehouseVisible} setVisible={setChangeWarehouseVisible} />
            <AddWarehouseShelfModal
                visible={addShelfVisible}
                onCancel={() => setAddShelfVisible(false)}
            />
        </YhBox>
    )
}
